import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import type { IconSet } from 'vuetify'
import { ZIconsLoader } from '@tsyl/zapan2'
import { commonVuetifyOptions } from './basicVuetify'

export default createVuetify({
  ...commonVuetifyOptions,
  theme: {
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#A21E25',
          'primary-lighten-1': '#f8d7d8', // 75% lighter
          background: '#F0F2F6',
          secondary: '#577CA0',
          'secondary-darken-1': '#585858',
          'secondary-lighten-1': '#d4dee8', // 75% lighter
          info: '#577CA0',
        },
      },
      dark: {
        dark: true,
        colors: {
          primary: '#A21E25',
          'primary-lighten-1': '#f8d7d8', // 75% lighter
          background: '#1E1E1E',
          secondary: '#577CA0',
          'secondary-darken-1': '#585858',
          'secondary-lighten-1': '#d4dee8', // 75% lighter
          info: '#577CA0',
        },
      },
    },
  },
  // This will make vitest to
  icons: {
    sets: {
      ...(ZIconsLoader as Record<string, IconSet>),
    },
  },
})
